import { gql, useMutation } from '@apollo/client'

const EXAM_ANSWERS_COMMIT = gql`
  mutation ExamAnswersCommit(
    $examAnswersInput: [ExamAnswerInputObject!]!
    $fetchLessonProgressInput: FetchLessonProgressInputObject!
  ) {
    examAnswersCommit(
      input: {
        examAnswersInput: $examAnswersInput
        fetchLessonProgressInput: $fetchLessonProgressInput
      }
    ) {
      status
    }
  }
`

interface IAssociativeOption {
  firstAssertionId: number
  secondAssertionId: number
}

interface IExamAnswersInput {
  examQuestionId: number
  multipleChoiceOptionId?: number
  correct?: boolean
  associativeOptionsAttributes?: IAssociativeOption[]
}

interface IFetchLessonProgressInput {
  enrollmentId: number
  lessonId: number
  progressCardId: number
}

export interface IExamAnswersCommitProps {
  examAnswersInput: IExamAnswersInput[]
  fetchLessonProgressInput: IFetchLessonProgressInput
}

export type IHandleExamAnswersCommit = Promise<{ status: string }>

export const useExamAnswersCommit = () => {
  const [examAnswersCommit, { loading, error }] =
    useMutation(EXAM_ANSWERS_COMMIT)

  const handleExamAnswersCommit = async ({
    examAnswersInput,
    fetchLessonProgressInput,
  }: IExamAnswersCommitProps): Promise<{ status: string }> => {
    const response = await examAnswersCommit({
      variables: {
        examAnswersInput,
        fetchLessonProgressInput,
      },
    })
    return response.data.examAnswersCommit
  }

  return { handleExamAnswersCommit, loading, error }
}
